import { render, staticRenderFns } from "./GuardianInfo.vue?vue&type=template&id=17e1b99c&scoped=true&"
import script from "./GuardianInfo.vue?vue&type=script&lang=ts&"
export * from "./GuardianInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GuardianInfo.vue?vue&type=style&index=0&id=17e1b99c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1b99c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VContainer,VIcon,VRow,VTooltip})
